<template>
  <settings-modal
    class="payment-accept-modal"
  >
    <template slot="heading">{{ heading }}</template>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        id="accept"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentReturnHoldModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        returnToHoldBySupervisorApiRequest: new ApiRequest(PaymentApi.returnToHoldBySupervisor)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      payment () {
        return this.modal.data.payment
      },
      heading () {
        return `Return to hold payment ${this.payment.id}?`
      },
      loading () {
        return this.returnToHoldBySupervisorApiRequest.loading
      },
      error () {
        return this.returnToHoldBySupervisorApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.returnToHoldBySupervisorApiRequest
          .execute(this.payment.id)
          .then(this.returnToHoldBySupervisorSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      returnToHoldBySupervisorSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment has been successfully returned to hold.' }
          })
        }, 100)
      }
    }
  }
</script>
